import { withLazyFeatureGateErrorBoundary } from '@office-start/office-home-app-shared';
import { lazy } from 'react';
export var StorageErrorMessageBar = withLazyFeatureGateErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "semb" */ '@office-start/storage-error-messagebar-component');
}), 'StorageErrorMessageBar', {
    disabledFeatureGateSelector: function (featureGates) { var _a; return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.storageErrorGates) === null || _a === void 0 ? void 0 : _a.storageErrorMessageBarEnabled); },
});
//# sourceMappingURL=StorageErrorMessageBar.js.map